export enum TYPOGRAPHY_TYPE {
  REGULAR = "type-regular",
  BOLD = "type-bold",
  TITLE_FOUR = "title-four",
  TITLE_FIVE = "title-five",
}

export interface TypographyProps {
  children: React.ReactNode;
  type: TYPOGRAPHY_TYPE;
}
